import { render, staticRenderFns } from "./ExhibitorProfile.vue?vue&type=template&id=06612652&"
import script from "./ExhibitorProfile.vue?vue&type=script&lang=js&"
export * from "./ExhibitorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports